import { Group, Select } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import ExportComponent from "utiles/export";

const ReportFilters = ({
  data,
  headers,
  reportTitle,
  filterSubtitle,
  fileNamePrefix,
  onFetch,
  onTimeRangeChange,
  onDateRangeChange,
  timeRange: externalTimeRange,
  startDate: externalStartDate,
  endDate: externalEndDate,
}) => {
  const [timeRange, setTimeRange] = useState(externalTimeRange || null);
  const [selectedStartDate, setSelectedStartDate] = useState(
    externalStartDate || null,
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    externalEndDate || null,
  );

  useEffect(() => {
    setTimeRange(externalTimeRange || null);
  }, [externalTimeRange]);

  useEffect(() => {
    setSelectedStartDate(externalStartDate || null);
  }, [externalStartDate]);

  useEffect(() => {
    setSelectedEndDate(externalEndDate || null);
  }, [externalEndDate]);

  useEffect(() => {
    if (onTimeRangeChange) {
      onTimeRangeChange(timeRange);
    }
  }, [timeRange, onTimeRangeChange]);

  useEffect(() => {
    if (onDateRangeChange) {
      onDateRangeChange({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
      });
    }
  }, [selectedStartDate, selectedEndDate, onDateRangeChange]);

  return (
    <Box style={{ position: "relative", marginBottom: 16, marginTop: 10 }}>
      <Group
        justify="space-between"
        align="flex-start"
        style={{
          flexDirection: "row",
          flexWrap: "nowrap",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <Select
          style={{ minWidth: "140px" }}
          data={[
            { value: "DAILY", label: "Daily" },
            { value: "WEEKLY", label: "Weekly" },
            { value: "MONTHLY", label: "Monthly" },
            { value: "QUARTERLY", label: "Half Year" },
            { value: "YEARLY", label: "Yearly" },
          ]}
          value={timeRange}
          onChange={(value) => setTimeRange(value)}
          placeholder="Period"
          withinPortal
          clearable
        />
        <DatePicker
          style={{ minWidth: "140px" }}
          value={selectedStartDate}
          onChange={setSelectedStartDate}
          placeholder="Start Date"
          popoverProps={{ withinPortal: true, zIndex: 10001 }}
          clearable
        />
        <DatePicker
          style={{ minWidth: "140px" }}
          value={selectedEndDate}
          onChange={setSelectedEndDate}
          placeholder="End Date"
          popoverProps={{ withinPortal: true, zIndex: 10001 }}
          clearable
        />
        <ExportComponent
          data={data || []}
          headers={headers || []}
          reportTitle={reportTitle}
          filterSubtitle={filterSubtitle}
          fileNamePrefix={fileNamePrefix}
          onFetch={onFetch}
        />
      </Group>
    </Box>
  );
};

ReportFilters.propTypes = {
  data: PropTypes.array,
  headers: PropTypes.array,
  reportTitle: PropTypes.string,
  filterSubtitle: PropTypes.string,
  fileNamePrefix: PropTypes.string,
  onTimeRangeChange: PropTypes.func,
  onDateRangeChange: PropTypes.func,
  onFetch: PropTypes.func,
  timeRange: PropTypes.string,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
};

ReportFilters.defaultProps = {
  data: [],
  headers: [],
  reportTitle: "",
  filterSubtitle: "",
  fileNamePrefix: "report",
  onTimeRangeChange: null,
  onDateRangeChange: null,
  onFetch: null,
  timeRange: null,
  startDate: null,
  endDate: null,
};

export default ReportFilters;
